// Old-site uploads are served locally as web-sized WebP copies under
// /media/uploads/, mirroring WordPress's YYYY/MM/ layout. Any reference to an
// upload — a WordPress or former Supabase URL, or a bare "2026/01/752-scaled.jpg"
// path — resolves to its local copy. WordPress's "-scaled" suffix is dropped
// because the local copy is generated from the same image.
// See tools/media/README.md for how the copies are produced.

// Bump when images are regenerated in place (e.g. re-watermarked): the CDN caches
// images for a week by URL, so a new query string is what makes the change show.
export const MEDIA_VERSION = "wm1";
const v = (url) => (url.includes("?v=") ? url : `${url}?v=${MEDIA_VERSION}`);

const UPLOAD = /(?:^|\/uploads\/)(\d{4}\/\d{2}\/[^?#]+)(?:\?.*)?$/;

// Uploads whose base name exists with two extensions keep the extension in the
// local name so neither overwrites the other.
const EXT_SUFFIXED = new Set(
  ["10", "10-1", "12", "12-1", "6", "6-1", "8", "8-1"].map((n) => `2025/10/${n}-jpeg`)
);

function localBase(ref) {
  const m = typeof ref === "string" && ref.match(UPLOAD);
  if (!m) return null;
  const rel = m[1];
  const dot = rel.lastIndexOf(".");
  const base = rel.slice(0, dot).replace(/-scaled$/, "");
  const suffixed = `${base}-${rel.slice(dot + 1).toLowerCase()}`;
  return EXT_SUFFIXED.has(suffixed) ? suffixed : base;
}

// Full-size (max 1600px) image for a hero, feature or the photo viewer.
export function mediaSrc(ref) {
  const base = localBase(ref);
  if (base) return v(`/media/uploads/${base}.webp`);
  return typeof ref === "string" && ref.startsWith("/projects/") ? v(ref) : ref;
}

// Small (max 640px) image for gallery grids.
export function mediaThumb(ref) {
  const base = localBase(ref);
  if (base) return v(`/media/uploads/${base}.thumb.webp`);
  return typeof ref === "string" && ref.startsWith("/projects/") ? v(ref) : ref;
}

// Old-site videos are re-encoded to 720p H.264 with a WebP poster frame.
export function videoSrc(ref) {
  const m = ref.match(UPLOAD);
  return m ? `/media/uploads/${m[1].replace(/\.[^.]+$/, ".mp4")}` : ref;
}

export function videoPoster(ref) {
  const m = ref.match(UPLOAD);
  return m ? `/media/uploads/${m[1].replace(/\.[^.]+$/, ".poster.webp")}` : undefined;
}
